import React from 'react';
import { X } from 'lucide-react';
import { BuilderIconButton } from '@/components/BuilderIconButton';
import styles from './DrawerHeader.module.scss';

interface DrawerHeaderProps {
  title: string;
  onClose: () => void;
}

/** Title-left / close-button-right header, matching the reference design's
 * `.drawer-head` — the opposite order from AntD Drawer's default (close-then-title). */
export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ title, onClose }) => (
  <div className={styles.row}>
    <span>{title}</span>
    <BuilderIconButton icon={<X style={{ width: '1em', height: '1em' }} />} title="Close" onClick={onClose} />
  </div>
);

export default DrawerHeader;
